import { com, kotlin } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import permissionGrantDTO, { PermissionGrantDTO } from '../../../../domain/permission/PermissionGrantDTO'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import serializeToJsonString = com.eidu.sharedlib.entity.util.serializeToJsonString
import PermissionGrantId = com.eidu.sharedlib.entity.permission.PermissionGrantId
import Permission = com.eidu.sharedlib.entity.permission.Permission
import PermissionPolicyId = com.eidu.sharedlib.entity.permission.PermissionPolicyId
import UpdatePermissionGrantRequest = com.eidu.sharedlib.entity.api.permissions.UpdatePermissionGrantRequest
import PermissionGrant = com.eidu.sharedlib.entity.permission.PermissionGrant
import KtSet = kotlin.collections.KtSet
import EntitySelector = com.eidu.sharedlib.entity.selector.EntitySelector

export type UpdatePermissionGrantParameters = {
  id: PermissionGrantId
  userSelector: EntitySelector
  permissions: readonly Permission[]
  policyIds: readonly PermissionPolicyId[]
}

const updatePermissionGrant = async ({
  id,
  userSelector,
  permissions,
  policyIds,
}: UpdatePermissionGrantParameters): Promise<PermissionGrantDTO> => {
  return fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/permissions/grants/${id.toString()}`,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: serializeToJsonString(
        new UpdatePermissionGrantRequest(
          new PermissionGrant(userSelector, KtSet.fromJsSet(new Set(permissions)), KtSet.fromJsSet(new Set(policyIds)))
        )
      ),
      method: 'PUT',
    }
  ).then(async (response) => {
    if (response.status !== 200)
      throw Error(`Unexpected response code ${response.status} from updatePermissionGrant endpoint`)
    return permissionGrantDTO((await response.json()).document)
  })
}

export default updatePermissionGrant
